import { type ObjectValuesUnionType } from '../utils/typing';

export const BalanceChangeTypes = Object.freeze({
  DEBIT: 'debit',
  CREDIT: 'credit',
});
export type BalanceChangeType = ObjectValuesUnionType<typeof BalanceChangeTypes>;

export const BalanceChangeOrigins = Object.freeze({
  BETTING: 'betting',
  TABLE: 'table',
  OPERATOR: 'operator',
});
export type BalanceChangeOrigin = ObjectValuesUnionType<typeof BalanceChangeOrigins>;
